import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
import _imports_0 from '../image/eco_line.png';
var _hoisted_1 = {
  class: "big_box"
};
var _hoisted_2 = {
  class: "container"
};

var _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "eco_intro"
}, " 我们以战略合作和自主研发结合的公司模式，与全球生态伙伴，包括生物科技公司、学术机构和临床专家深度合作，创新驱动前沿科学转化、推动具有临床巨大价值和差异化的治疗，加速满足中国及全球广大患者急需的创新治疗。 ", -1);

var _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "eco_title"
}, "业内权威合作伙伴", -1);

var _hoisted_5 = {
  class: "eco_flex"
};
var _hoisted_6 = {
  class: "eco_left_img col-lg-4 col-md-4 col-sm-12 col-xs-12"
};
var _hoisted_7 = ["src"];
var _hoisted_8 = {
  class: "eco_right_contet col-lg-8 col-md-8 col-sm-12 col-xs-12"
};
var _hoisted_9 = {
  class: "eco_r_t"
};
var _hoisted_10 = {
  key: 0
};
var _hoisted_11 = ["innerHTML"];
var _hoisted_12 = {
  class: "eco_r_link"
};
var _hoisted_13 = ["onClick"];

var _hoisted_14 = /*#__PURE__*/_createElementVNode("div", {
  class: "eco_close"
}, null, -1);

var _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "eco_line"
}, null, -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_collapse = _resolveComponent("el-collapse");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _hoisted_4, _createVNode(_component_el_collapse, {
    accordion: false,
    modelValue: $setup.activeNames,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $setup.activeNames = $event;
    })
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.partnerList, function (item, index) {
        return _openBlock(), _createElementBlock("div", {
          class: "eco_content_box",
          key: index
        }, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
          src: item.imageUrl,
          class: "eco_l_img"
        }, null, 8, _hoisted_7)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createTextVNode(_toDisplayString(item.companyName), 1), item.aliasName ? (_openBlock(), _createElementBlock("span", _hoisted_10, "（" + _toDisplayString(item.aliasName) + "）", 1)) : _createCommentVNode("", true)]), _createElementVNode("div", {
          class: "eco_r_c",
          innerHTML: item.description
        }, null, 8, _hoisted_11), _createElementVNode("span", _hoisted_12, [_createTextVNode(" 发现更多关于" + _toDisplayString(item.companyName) + "：", 1), _createElementVNode("a", {
          class: "eco_link",
          onClick: function onClick($event) {
            return $setup.jumpWeb(item.websiteLink);
          }
        }, _toDisplayString(item.websiteLink), 9, _hoisted_13)]), _hoisted_14])])]), _hoisted_15]);
      }), 128))];
    }),
    _: 1
  }, 8, ["modelValue"])])]);
}